// src/utils/auth.js
import { jwtDecode } from 'jwt-decode';

export function getToken() {
  return localStorage.getItem('token');
}

export function getUserInfo() {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isTokenExpired() {
  const user = getUserInfo();
  if (!user) return true;
  return user.exp < Date.now() / 1000;
}
